import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { CarbonPartCommission } from './models/part-commission';
import { CarbonPartCommissionPayload } from './models/part-commission-payload';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class CarbonPartCommissionService
  extends StoreBaseService<CarbonPartCommission, CarbonPartCommissionPayload> {

  get entityType(): string {
    return EntityTypes.carbonPartCommission;
  }

  get resourceName(): string {
    return 'carbon/part-commission';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
